<template>
    <b-modal
        title-tag="h2"
        ref="modalDeleteItem"
        title="Delete Item"
        ok-title="Delete"
        @ok="proceedDelete()"
        footer-class="d-flex justify-content-between"
        lazy
    >
        Are you sure you want to delete
        <strong v-if="item && item.name" class="px-1">{{ item.name }}</strong>
        from this return?
    </b-modal>
</template>
<script type="text/javascript">
/**
 * @name ReturnItemsDelete
 * @description Modal to delete return item
 * @see apps/application/views/staff/billing/return/return/sub/item/wizard/confirm.php
 */

import BillingReturnItems from "@/services/billing/billing-return-item";

export default {
    data() {
        return {
            item: null
        };
    },
    methods: {
        open(item) {
            this.item = item;
            this.$refs.modalDeleteItem.show();
        },
        proceedDelete() {
            BillingReturnItems.removeReturnItem(this.item.id)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.message);
                        this.$emit("reload");
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to delete item", "danger");
                    console.error(error);
                });
        }
    }
};
</script>
